<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    width="35%"
    @close="handleClose"
  >
    <el-form :model="phoneForm" :rules="rules" ref="forms" label-width="120px">
      <template v-if="status === 0">
        <el-form-item :label="this.$t('center.phone')" prop="phone">
          <el-input
            v-model="phoneForm.phone"
            :placeholder="this.$t('center.plaPhone')"
          >
            <template slot="prepend">
              <el-select
                v-model="phoneForm.prefix"
                :placeholder="$t('common.select')"
                style="width:85px"
                @change="changeCountryCode"
              >
                <el-option
                  v-for="country in countryList"
                  :key="country.value"
                  :label="country.label"
                  :value="country.label"
                >
                  <span style="float: left">{{ country.key }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    country.label
                  }}</span>
                </el-option>
              </el-select>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item :label="this.$t('center.code')" prop="code">
          <el-input v-model="phoneForm.code">
            <template slot="append">
              <el-button
                type="primary"
                @click="getPhoneCode"
                v-if="timer === null"
                >{{ $t('center.getCode') }}
              </el-button>
              <el-button type="info" v-else>{{ count }} s</el-button>
            </template>
          </el-input>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item :label="this.$t('center.phone')" prop="phone">
          <el-input v-model="phoneForm.phone" placeholder="" :disabled="true">
            <template slot="prepend">{{ phoneForm.prefix }}</template>
          </el-input>
        </el-form-item>
        <el-form-item :label="this.$t('center.code')" prop="code">
          <el-input v-model="phoneForm.code">
            <template slot="append">
              <el-button
                type="primary"
                @click="getVerPhoneCode"
                v-if="timer === null"
                >{{ $t('center.getCode') }}
              </el-button>
              <el-button type="info" v-else>{{ count }}s</el-button>
            </template>
          </el-input>
        </el-form-item>
      </template>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submit">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as companyApi from '@/services/companyApi'
import { validatorPhoneRule } from '@/utils/validatorRule.js'
import { sendPhoneCode } from '@/services/userCenter.js'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    status: {
      type: [Number, String]
    },
    userInfo: {
      type: Array
    }
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val) {
          this.isFormatPhone()
        }
      },
      immediate: true
    }
  },
  data() {
    let checkBind = (rule, value, callback) => {
      // 校验手机
      let params = {
        content: value,
        type: 2
      }
      companyApi.checkBindPhoneOrEmail(params).then(data => {
        if (data.code === '00000000') {
          return callback()
        } else {
          return callback(new Error(this.$t('common.alreadyBindPhone')))
        }
      })
    }
    return {
      countryList: [],
      count: 60,
      timer: null,
      phoneForm: {
        prefix: '+86',
        phone: '',
        code: ''
      },
      rules: {
        phone: validatorPhoneRule(true, checkBind),
        code: this.validatorInputEmptyRule(true)
      }
    }
  },
  methods: {
    isFormatPhone() {
      let temp = JSON.parse(JSON.stringify(this.userInfo))
      if (temp.phoneState !== undefined && temp.phoneState !== '0') {
        // 绑定再回显
        this.phoneForm.phone = this.phoneFormat(temp.phone)
      }
    },
    submit() {
      let temp = Object.assign({}, this.phoneForm)
      if (this.status === 1) {
        temp.phone = this.userInfo.phone
      }
      this.$emit('submitPhone', temp)
    },
    sendCode(params) {
      sendPhoneCode(params).then(data => {
        if (data.code === '00000000') {
          this.beginTiming()
        } else if (data.code === 'E0010351') {
          this.$message({
            message: data.message,
            type: 'warning'
          })
        } else {
          this.errorMessage(data.message)
        }
      })
    },
    getVerPhoneCode() {
      if (this.count === 60) {
        let params = {
          phone: this.userInfo.phone,
          prefix: this.phoneForm.prefix,
          type: 'checkPhone'
        }
        this.sendCode(params) // 身份验证
      }
    },
    getPhoneCode() {
      if (this.count === 60) {
        this.$refs.forms.validateField('phone', errorPhone => {
          if (!errorPhone) {
            // 发送验证码接口 绑定
            let params = {
              phone: this.phoneForm.phone,
              prefix: this.phoneForm.prefix,
              type: 'bindPhone'
            }
            this.sendCode(params)
          } else {
            return false
          }
        })
      }
    },
    handleClose() {
      this.$emit('closePhone')
      this.$refs.forms.resetFields()
      this.count = 60
      clearInterval(this.timer)
      this.timer = null
    },
    init() {
      this.phoneForm.phone = ''
      this.phoneForm.code = ''
      this.phoneForm.prefix = '+86'
      this.count = 60
      clearInterval(this.timer)
      this.timer = null
    },
    beginTiming() {
      this.timer = setInterval(() => {
        this.count--
        if (this.count === 0) {
          this.count = 60
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    loadCountry() {
      companyApi.loadCountry().then(data => {
        this.countryList = []
        let key = Object.keys(data)
        key.forEach(item => {
          this.countryList.push({
            key: this.$t('contry.' + item),
            value: item,
            label: '+' + data[item]
          })
        })
      })
    },
    changeCountryCode(value) {
      this.countryList.filter(item => {
        if (item.value === value) {
          this.phoneForm.prefix = item.label
          return ''
        }
      })
    }
  },
  mounted() {
    this.loadCountry()
  }
}
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/modules/personCenter/dialog/phoneDialog.vue